import {createReducer, on} from '@ngrx/store';
import {EntityState, EntityAdapter, createEntityAdapter} from '@ngrx/entity';
import * as FieldTypeActions from '../_actions/field-type-entity.actions';
import {IFieldType} from '../_interface/ifield-type';

export const featureKey = 'fieldTypeEntities';

export interface State extends EntityState<IFieldType> {
	loaded: boolean;
}

export const adapter: EntityAdapter<IFieldType> = createEntityAdapter<IFieldType>(
	{selectId: model => model.entryFieldTypeId}
);

export const initialState: State = adapter.getInitialState({
	loaded: false
});


export const reducer = createReducer(
	initialState,
	on(FieldTypeActions.loadFieldTypes,
	(state, action) => {
		return adapter.setAll(action.fieldTypes, {...state, loaded: true});
	})
);
